const message = {
  menu: {
    "user-menu": "사용자 메뉴",
    "my-meeting": "참여할 회의",
    "my-education": "참여할 교육",
    "reserve-meeting": "회의 예약",
    "my-calendar": "My Calendar",
    "room-open-meeting": "일반회의 예약",
    "video-open-meeting": "화상회의 예약",
    "open-meeting": "회의 개설",
    "device-list": "장비 현황",
    "my-end-meeting-list": "참여한 회의",
    "daily-meeting": "일간 현황",
    "weekly-meeting": "주간 현황",
    "monthly-meeting": "월간 현황",
    "my-record-file": "내 녹화 파일",
    "meeting-reserve": "회의 예약",
    "reserve-approve-mgt": "예약 승인 관리",
    profile: "프로필",
    "admin-menu": "관리자 메뉴",
    dashboard: "대시보드",
    statistics: "통계",
    "meetingroom-mgr": "회의실",
    "device-mgr": "화상장비",
    "layout-mgr": "레이아웃 관리",
    "role-mgr": "권한 관리",
    "user-mgr": "사용자 관리",
    "record-mgr": "녹화파일 관리",
    "webex-license": "웹엑스 라이센스",
    "system-mgr": "시스템",
    "cms-mgr": "CMS 관리",
    log: "로그",
    "help-desk": "Help Desk",
    "cisco-webex-hub": "Cisco Webex Hub",
    "cospaces-mgr": "Cospaces 관리",
    "external-users":
      " \u00A0\u00A0\u00A0\u00A0\u00A0협력회사\u00A0\u00A0\u00A0\u00A0\u00A0 사용자 등록",
    "external-edu-users": "강사 등록",
    "external-users-mgt": "사용자 관리",
  },
  dialog: {
    warning: {
      delete: "삭제",
      cancel: "취소",
      "rejected-reason": "반려 사유",
      rejected: "반려",
      "rejected-reason-required": "반려사유는 필수값 입니다.",
    },
    info: {
      confirm: "확인",
    },
    save: "저장",
    add: "추가",
    close: "닫기",
  },
  util: {
    floor: "층",
  },
  "page-header": {
    meeting: "화상회의",
    lms: "화상교육",
    "notice-message": "Welcome {name}님 {lastAccessTime}",
    "meeting-cnt-msg": "금년누적 : {meetingCnt}회 개최,",
    "attendee-cnt-msg": "{attendeeCnt}명 참여,",
    "reduce-cost-billion": "{billion}억",
    "reduce-cost-message": "절감효과 : {billion} {manwon}만원",
  },
  "login-warning": {
    msg: `본 사이트는 임직원 및 인가된 사용자만 사용할 수 있습니다.</br> 불법 사용 시에는 법령에 의해 민/형사상 책임을 질 수 있습니다.`,
  },
  page: {
    "my-meeting": {
      node: "노드",
      "meeting-time-line": "회의 타임라인 Today",
      "meeting-time-line-no-result": "오늘의 회의가 없습니다.",
      "meeting-time-line-no-meeting-room": "선택된 회의실이 없습니다.",
      "invaild-cospaceuri": "화상회의실 번호가 유효하지 않습니다.",
      cospaceuri: "화상회의실 번호",
      "lms-cospaceuri": "화상강의방 번호",
      "manual-join": "수동 참가",
      "meeting-join": "참여",
      "all-my-meeting": "나의 전체 회의",
      "approve-request-meeting": "승인 요청 예약",
      "meeting-reserve": "회의 예약",
      "immediate-reserve": "즉시 회의",
      "edit-display-name": "참석자명 설정",
      "edit-display-name-label": "참여 이름을 설정 하세요",
      "all-meeting-grid": {
        "add-teacher": "외부 교수 추가",
        "company-group": "회사",
        "meeting-date": "회의 날짜",
        "meeting-time": "회의 시간",
        type: "회의 구분",
        "meeting-type": "회의 유형",
        "meeting-name": "회의명",
        "meeting-room-number": "화상회의실 번호",
        "meeting-sta-time": "시작 시간",
        "meeting-end-time": "종료 시간",
        creator: "예약자",
        departments: "주관부서",
        "streaming-uri": "스트리밍주소",
        organizer: "예약자",
        host: "주관자",
        attendee: "참여자",
        "re-reservation": "재예약",
        contents: "참석자",
        building: "건물",
        "meeting-room": "회의실",
        "create-meeting-room": "대면 회의실",
        "attend-meeting-room": "회의실",
        repeat: "반복",
        "repeat-end-date": "반복 종료 날짜",
        status: "상태",
        control: "제어",
        "approve-status": "승인상태",
        detail: "상세정보",
        cospace: "회의방 번호",
        modify: "수정",
        delete: "삭제",
        approve: "승인",
        reject: "반려",
        skype: "Skype",
        join: "참여",
        record: "녹화",
        "class-info": "과목 정보",
        "lms-meeting-day": "교육 일시",
        "lms-meeting-date": "교육 날짜",
        "lms-meeting-time": "교육 시간",
        "lms-meeting-name": "과정명",
      },
      "cur-join-cnt": "참여 노드 수",
      "home-teacher": "담임교수",
      "teacher-search": "교수 검색",
      class: "과목명",
      teacher: "강의자",
      "lms-cospace": "화상교육",
      "lms-info": "상세정보",
      "lms-attendee": "수강생",
      people: "명",
      video: "화상",
      room: "일반",
      lecture: "강의",
      meeting: "회의",
      lms: "교육",
      "immediate-short": "즉시",
      "hostroom-declined": "대면 회의실<br>반려",
      "proceeding-streaming": "진행중<br>(스트리밍)",
      proceeding: "진행중",
      finish: "종료",
      requested: "요청중",
      rejected: "반려",
      approved: "승인",
      cancel: "요청 취소",
      reserve: "예약",
      "canceled-meeting": "회의가 취소 되었습니다.",
      "approve-meeting": "예약 승인",
      "approve-meeting-content": "선택하신 예약을 승인하시겠습니까?",
      "approved-meeting": "예약이 승인되었습니다.",
      "reject-meeting": "예약 반려",
      "reject-meeting-content": "선택하신 예약을 반려하시겠습니까?",
      "rejected-meeting": "예약이 반려 되었습니다.",
      "end-meeting": "회의 종료",
      "end-meeting-content": "선택하신 회의를 종료하시겠습니까?",
      "delete-meeting": "회의 취소",
      "delete-meeting-content": "선택하신 회의를 취소하시겠습니까?",
    },
    // components/schedules
    schedules: {
      "company-group": "회사",
      building: "회의실 빌딩",
      location: "지역",
      floor: "회의실 위치",
      room: "회의실",
      "meeting-reserve": "예약하기",
      total: "전체",
      "cancel-meeting": "회의 취소",
      "reserve-manager-info": "회의실 예약 안내",
      msg: {
        overtime: "지난 시간입니다. 현재 시간 이후로 예약이 가능합니다.",
        reserved: "회의실이 예약된 시간입니다. 다른 시간을 이용해 주세요.",
        end: "종료된 희의 입니다.",
        "not-modify": "회의가 시작되어 수정이 불가합니다.",
        "confirm-delete": "회의를 취소하시겠습니까?",
        "delete-meeting": "회의가 취소되었습니다.",
        "request-manager": "관리자에게 문의해서 예약하세요.",
        "no-selected-video-rooms": `선택한 화상 회의실이 없습니다. 화상 회의실을 선택해 주세요.`,
        "no-selected-video-rooms-subheading": `(*화상회의실에서 일반회의를 하실 때에는 왼쪽 사용자 메뉴의 ‘일반회의 예약’에서 동일한 회의실을 찾아 예약해 주세요.</br> 불필요하게 ‘화상회의 예약’을 할 경우, 화상 연결 라이선스를 점유하게 되어, 필요한 사람이 사용하지 못할 수도 있습니다.)`,
        "reserve-manager-info":
          "회의실 예약을 위해 예약 관리자에게 문의하시기 바랍니다.",
        "reserve-dept-info":
          "예약이 불가능한 회의실 입니다. 해당 회의실 관리자에게 권한을 요청하세요.",
        "dup-rooms":
          "{dupRooms} 회의실이 선택한 시간에 예약이 되어 있습니다. 다른 회의실 선택 또는 다른 시간을 선택하시기 바랍니다.",
      },
      confirm: "확인",
      "room-detail": {
        title: "회의실 정보",
        company: "회사",
        building: "빌딩",
        "room-name": "회의실",
        "room-type": "타입",
        manager: "관리자",
        mobile: "연락처",
        items: "장비",
        ip: "단말 IP",
        version: "SW 버전",
        "display-name": "DN",
        manufacturer: "제조사",
        model: "모델",
      },
    },
    "daily-meeting": {
      "room-name": "회의실명",
      "room-type": "타입",
      "room-capacity": "인원",
    },
    "weekly-meeting": {},
    "monthly-meeting": {},
    "record-mgr": {
      "meeting-date": "회의 날짜",
      "meeting-time": "회의 시간",
      "gird-title": "녹화 파일 리스트",
      "meeting-name": "회의명",
      "meeting-sta-time": "회의 시작 시간",
      "meeting-end-time": "회의 종료 시간",
      creator: "예약자",
      "record-name": "녹화 파일 이름",
      "file-size": "파일 사이즈",
      "recording-time": "녹화 시간",
      streaming: "스트리밍",
      download: "다운로드",
      delete: "삭제",
      "delete-title": "녹화파일 삭제",
      "delete-record-content": "선택한 녹화파일을 삭제 하시겠습니까?",
      "deleted-record": "녹화파일이 삭제 되었습니다.",
    },
    "meeting-reserve": {
      "approval-required": " (승인 필요)",
      required: "* 필수입력",
      "host-room-msg":
        "주관자가 있는 회의실을 한 곳 선택, 없으면 없음을 선택해 주시기 바랍니다.",
      "room-msg":
        "전용 장비(코덱)를 자동으로 초대할 상대 회의실 입력, 없으면 없음을 선택해 주시기 바랍니다.",
      "host-msg": "예) CEO, ㅇㅇ부사장,ㅇㅇ본부장,ㅇㅇ처장,ㅇㅇ부장 등",
      "content-msg": "예) 각 본부장, ICT담당부장, 배전설비 담당자 등",
      "meeting-reserve-info": "회의 예약 정보",
      "control-user": "회의제어",
      "meeting-name": "회의명",
      "meeting-time": "일시",
      repeat: "반복",
      "custom-meeting-type": "회의 유형",
      "meeting-type": "회의 방식",
      "general-meeting": "일반 회의",
      "regular-meeting": "정기 회의",
      "in-general": "한전시스템 활용(일반)",
      "in-important": "한전시스템 활용(중요)",
      "out-general": "외부시스템 활용(일반)",
      "out-important": "외부시스템 활용(중요)",
      room: "일반회의",
      video: "화상회의",
      immediate: "즉시회의",
      "lecture-mode": "수강자 모드",
      "lecture-mode-desc": " <수강자는 카메라, 마이크 OFF상태>",
      "room-short": "일반",
      "video-short": "화상",
      "immediate-short": "즉시",
      "meeting-record": "녹화",
      option: "선택 옵션",
      record: "녹화하기",
      contents: "참석자",
      mute: "음소거",
      panelist: "패 널",
      teacher: "발언자(강사)",
      host: "주관자",
      invite: "초대하기",
      "invite-msg":
        "메일, 카카오톡 수신 할 사람을 한 명 이상 입력해 주시기 바랍니다.",
      "control-msg": "회의 제어 권한을 할당 할 사람을 입력 해 주시기 바랍니다.",
      attendee: "참여자",
      "organization-chart": "조직도",
      "search-user": "검색된 조직 목록",
      favorites: "즐겨찾기",
      "search-meeting": "실시간 회의방 현황 그래프보기",
      "license-meeting": "실시간 회의방 현황 그래프보기",
      "meeting-count-info": "실시간 회의방 현황",
      upload: "업로드",
      "excel-download": "양식 다운로드",
      "excel-upload": "엑셀 업로드",
      "excel-upload-popup-msg":
        "아래의 양식을 다운로드 하여 수정 한 후 업로드 해 주세요.",
      list: "목록",
      "host-meeting-room": "대면 회의실",
      "meeting-room": "상대 회의실",
      notice: "알림",
      "notice-minute": "분전 E-Mail 알림",
      reserve: "예약하기",
      "edit-end": "종료하기",
      edit: "수정하기",
      end: "회의 종료",
      delete: "회의 취소",
      back: "뒤로가기",
      email: "이메일",
      "kakao-talk": "카카오톡",
      sms: "문자",
      "attendee-excel-upload-msg": "{count}명의 참여자가 추가 되었습니다.",
      "panelist-excel-upload-msg": "{count}명의 패널이 추가 되었습니다.",
      "invaild-email-msg": "Email만 입력이 가능 합니다.",
      search: "검색",
      "attendee-invite": "참석자 초대",
      organization: {
        search: "성명/로그인 아이디 검색",
        "search-users": "임직원 검색",
        "attendee-list": "참여자 리스트",
        team: "부서",
        position: "직급",
        "emp-num": "사번",
        name: "이름",
        email: "이메일",
        delete: "삭제",
        save: "저장",
        close: "닫기",
        "external-participants": "외부참여자",
        "search-result": "총 {count}명",
        "search-word": "검색어",
      },
      "meeting-room-popup": {
        name: "이름",
        department: "부서",
        capacity: "수용인원",
        floor: "위치",
        type: "룸 타입",
        status: "상태",
        "reserved-status": "예약 상태",
        "personal-device": "개인단말",
        "room-search": "회의실 검색",
        "personal-search": "개인단말 검색",
        "device-name": "단말 이름",
        Building: "건물",
        ip: "IP",
        uri: "Uri",
        "meeting-room-list": "회의실 리스트",
        "device-list": "참여 단말 리스트",
        delete: "삭제",
        "missing-room-msg": "회의실을 선택 하세요",
        reservable: "예약 가능",
        unreservable: "예약 불가",
        "only-one-select-msg": "회의실을 1개이상 선택 할 수 없습니다.",
        ok: "확인",
      },
      close: "닫기",
      add: "추가",
      change: "변경",
      "all-delete": "전체 삭제",
      "editing-meeting": "회의를 수정중입니다...",
      "creating-meeting": "회의를 생성중입니다...",
      "delete-meeting": "회의를 취소하는 중입니다...",
      "all-license-used": "모든 라이선스가 사용 중 입니다.",
      "missing-meeting-name": "회의명을 입력해주세요.",
      "start-time-invalid": "시작시간이 종료시간보다 빠르거나 같습니다.",
      "end-time-invalid": "종료시간이 현재시간보다 빠르거나 같습니다.",
      "special-char-title-invalid": "제목에 특수문자를 입력할 수 없습니다.",
      "missing-attendee-room": "참여자, 회의실이 선택되지 않았습니다.",
      "missing-room": "회의실이 선택되지 않았습니다.",
      "missing-inside": "관내 참석 인원이 입력되지 않았습니다.",
      "missing-teacher": "강사가 선택되지 않았습니다.",
      "repeat-data-invalid": "반복 설정값이 올바르지 않습니다.",
      "repeat-max-hours": "반복회의 일 경우 24시간 미만으로 설정해야합니다.",
      "recent-meetings": "최근회의",
      "no-recent-meetings": "최근회의가 없습니다.",
      "bookmarked-meetings": "자주하는 회의",
      apply: "적용",
      "bookmarked-meetings-content": "자주하는 회의를 적용 하시겠습니까?",
      "no-bookmarked-meetings": "자주하는 회의가 등록되지 않았습니다.",
      "no-selected-meeting-room": "선택된 회의실이 없습니다.",
      "delete-bookmark-msg": "북마크가 삭제되었습니다.",
      "msg-all-licenses-used":
        "모든 라이센스가 사용중입니다. 다른시간을 이용하세요.",
      "msg-no-selected-room": "선택된 회의실이 없습니다.",
      "already-time-assigned":
        "회의실 예약이 되어 있어 시간변경이 불가능합니다.",
      "bookmark-add": "즐겨찾기 추가",
      "bookmark-edit": "즐겨찾기 수정",
      "bookmark-name": "즐겨찾기 명",
      modify: "수정",
      "bookmark-add-msg": "즐겨찾기가 추가되었습니다",
      "bookmark-edit-msg": "즐겨찾기가 수정되었습니다",
      "bookmark-delete-msg": "즐겨찾기가 삭제되었습니다",
    },
    profile: {
      "profile-info": "프로필 정보",
      "put-position-msg": "직책을 입력해주세요.",
      "empty-about-me-msg": "About Me에 입력한 내용이 표시됩니다.",
      "profile-edit": "프로필 수정",
      "can-not-edit": "수정이 불가합니다.",
      "edit-avatar-complete": "Avatar가 수정되었습니다.",
      "edit-profile-complete": "프로필이 수정 되었습니다.",
      "change-password": "패스워드 변경",
      "current-password": "현재 비밀번호",
      "new-password": "새 비밀번호",
      "new-password-check": "새 비밀번호 확인",
      "org-type-password-msg": "Local DB일 경우만 수정 가능 합니다.",
      "new-password-not-match":
        "새 비밀번호와 비밀번호 확인이 일치하지 않습니다.",
      "changed-password": "비밀번호가 변경되었습니다.",
      back: "뒤로가기",
      "update-profile": "프로필 업데이트",
      "init-info": "회사, 지역 변경",
      company: "회사",
      location: "지역",
    },
    dashboard: {
      msg: {
        "no-progress-meetings": "진행중인 회의가 없습니다",
        "next-meeting-info":
          "다음 회의는 {startDtime} 에 시작합니다. | 오늘 예정된 회의도 없습니다.",
      },
      "meeting-room": "회의실",
      "video-device": "화상회의 코덱 (총/활성/비활성)",
      "connected-video-device": "연결된 코덱",
      admin: "관리자",
      manager: "운영자",
      user: "사용자",
      meeting: "회의",
      "monthly-meeting": "월간 회의 현황",
      "room-meeting": "일반회의",
      "cms-license": "CMS 라이선스",
      "total-license": "총 라이선스",
      "using-license": "사용 라이선스",
      "video-meeting": "일반 영상회의",
      "conf-video-meeting": "고화질 영상회의",
      "preferred-meeting-room": "선호하는 회의실",
      "reserved-meeting": "시작 전인 회의 (전체)",
      "proceeding-meeting": "진행 중인 회의",
      "proceeding-meeting-total": "진행 중인 회의 (전체)",
      "proceeding-meeting-out": "진행 중인 회의 (외부시스템)",
      "proceeding-meeting-in": "진행 중인 회의 (한전시스템)",
      "meeting-join-cnt": "회의 참여 노드 (한전시스템)",
      "end-meeting": "이미 끝난 회의 (전체)",
      "all-meeting": "전체 회의",
      "video-meeting-room": "화상 회의실",
      "general-meeting-room": "일반 회의실",
      "all-license": "총 라이센스",
      "assigned-license": "할당된 라이센스",
      "daily-reserve-meeting": "오늘 회의",
      "weekly-reserve-meeting": "주간 회의",
      "monthly-reserve-meeting": "월간 회의",
      "reduce-cost-status": "인건비 절감 현황",
      "video-participants-status": "화상회의 참여자 현황",
      "total-inviter": "총 초대자",
      "actual-participants": "실제 참여자",
      "overall-participation-rate": "전체 참여율",
      "monthly-participation-rate": "월간 참여율",
      "weekly-participation-rate": "주간 참여율",
      "today-participation-rate": "오늘 참여율",
      "total-cost-savings": "전체 절감액",
      "monthly-cost-savings": "월간 절감액",
      "weekly-cost-savings": "주간 절감액",
      "today-cost-savings": "오늘 절감액",
      "meeting-list": "회의 리스트",
      "system-mgr": "시스템 관리",
      "meeting-room-status": "회의실 현황",
      "today-meeting-usage-status": "금일 회의 사용 현황",
      "participant-type": "사용자 타입",
      "system-license-management": "라이선스 관리",
      "cms-smp": "CMS (다자간 회의방)",
      "exp-e": "EXP-E (외부 접속 단말)",
      "exp-c": "EXP-C (화상 장비 등록)",
      system: "시스템",
      "total-down": "( Total / Down )",
      "system-license-status": "시스템 및 라이선스 현황",
      cms: "CMS",
      streaming: "스트리밍 (총/활성/비활성)",
      cucm: "CUCM",
      "streaming-server": "스트리밍서버",
      "internal-relay-server": "내부중계서버",
      "external-relay-server": "외부중계서버",
      "proxy-server": "프락시서버",
      "record-server": "녹화서버",
      "cms-version": "CMS Version",
      "cms-uptime": "CMS Uptime(시간,2021,03,26)",
      "record-license": "녹화 라이선스",
      "codec-license": "코덱 라이선스",
      "client-license": "클라이언트 라이선스",
    },
    statistics: {
      headquarters: "본부",
      "record-file": "녹화파일",
      "meeting-info": "회의 정보",
      "room-meeting-statistics": "일반회의 통계",
      "meeting-statistics": "회의 통계",
      "room-meeting-count": "일반 회의 수",
      "video-meeting-count": "화상 회의 수",
      "total-attendees-count": "총 초대자",
      "total-actual-attendees-count": "실제 참여자",
      "pc-attendees-count": "개인 참여자 (전화 연결 제외)",
      "mobile-attendees-count": "Mobile 참여자",
      "codec-attendees-count": "Codec 참여자",
      "video-meeting-statistics": "화상 회의 통계",
      "video-participants-status": "참여자 통계",
      "reduce-cost-status": "인건비 절감액",
      "cost-saving-unit": "원",
      "video-room-codec-statistics": "화상 회의실 통계",
      "video-meeting-usage-statistics": "화상 회의 사용량 통계",
      "pc-participant-statistics": "개인 참여자 통계",
      "mobile-participant-statistics": "Mobile 참여자 통계",
      "personal-codec-participant-statistics": "개인 Codec 참여자 통계",
      "meeting-count": "회의 건수",
      "reserved-meeting-count": "예약 회의 건수",
      "open-meeting-count": "개설된 회의 건수",
      "meeting-time-minute": "회의 시간 (분)",
      "average-meeting-time-minute": "평균 회의 시간 (분)",
      "user-meeting-info": "사용자별 회의 현황",
      "user-meeting-usage": "사용자별 회의 사용량",
      "room-meeting-usage": "회의실별 사용량",
      "reduce-cost": "절감 효과",
      "preferred-meeting-room": "선호하는 회의실",
      "status-by-meeting-room": "회의실별 회의 현황",
      "room-meeting": "일반회의",
      "video-meeting": "일반 영상회의",
      "conf-video-meeting": "고화질 영상회의",
      "lms-meeting": "화상교육",
      "room-video-meeting": "일반+화상",
      licenses: "라이센스",
      "dept": "부서",
      "status-by-time": "시간별 회의 건수",
      "status-by-day-of-the-week": "요일별 회의 건수",
      "daily-status": "일별 회의 건수",
      "monthly-status": "월별 회의 건수",
      "cms-licenses-status": "CMS 라이센스 현황",
      position: "직급",
      department: "조직",
      building: "본부",
      floor: "위치",
      "room-name": "회의실",
      capacity: "수용인원",
      "meeting-room-usage-count": "회의실 이용 횟수",
      "meeting-room-usage-time": "회의실 이용 시간(분)",
      "creat-meeting-count": "회의 생성 수",
      "meeting-participation-count": "회의 참여 수",
      "meeting-participation-time": "회의 참여 시간 (분)",
      "all-meeting-status": "회의 현황",
      "all-status": {
        "meeting-name": "회의명",
        "start-time": "시작시간",
        "end-time": "종료시간",
        creator: "예약자",
        host: "주관자",
        "creator-detail": "예약자(성명/부서)",
        building: "건물",
        "meeting-room": "회의실",
        "meeting-type": "회의타입",
        department: "부서",
        status: "상태",
        codec: "코덱",
        mobile: "모바일",
        pc: `PC/모바일`,
        "actual-attendees": "참여자",
        attendees: "초대자",
        "attendees-rate": "참석률",
        history: "히스토리",
        "detail-info": "상세정보",
        Delete: "삭제",
        video: "화상",
        room: "일반",
        lecture: "강의",
        proceeding: "진행중",
        finish: "종료",
        reserve: "예약",
      },
      history: {
        detail: "상세 정보",
        "meeting-name": "회의명",
        id: "회의ID",
        "client-agent": "접속 경로",
        "external-participant": "외부 참여자",
        ip: "IP 주소",
        "join-time": "참여시각",
        "leave-time": "나간시각",
        "meeting-key": "미팅번호",
        name: "이름",
        "emp-num": "사번",
        participation: "연결 상태",
        "participant-type": "참여자타입",
        duration: "참여시간(분)",
        "voip-duration": "음성참여시간(분)",
        attendance: "참여",
        nonattendance: "미참여",
        "attendees-msg":
          "초대 인원: {attendees}, 참여 인원 : {actualAttendees}",
        attendees: "참석자",
        codec: "화상장비",
        position: "직급",
        department: "부서",
        "codec-name": "회의실 명",
        building: "건물",
        company: "회사",
        area: "본부",
        "device-dn": "화상장비 DN",
        "webex-service": "전화연결 서비스",
        webex: "전화연결",
        type: "타입",
      },
      record: {
        name: "파일 이름",
        size: "사이즈",
        download: "다운로드",
      },
      search: "검색",
      user: "사용자",
      empnum: "사번",
      "join-attendee": "참석인원",
      savings: "절감액",
      email: "Email",
      "meeting-cnt": "개최회의",
      "meeting-attendee": "참여 노드 수",
      "company-group": "회사",
      creator: "예약자",
      organizer: "예약자",
      "meeting-name": "회의 이름",
      export: "EXPORT",
    },
    "meetingroom-mgr": {
      "custom-type-meeting": "인터넷망",
      "custom-type-no-meeting": "행정망",
      "custom-type-webex": "Webex",
      "custom-type-etc": "기타",
      sort: "정렬값",
      "country-sort": "국가 정렬값",
      "select-company-building": "회사 및 본부 선택",
      "building-search": "건물 검색",
      import: "Import",
      export: "Export",
      add: "빌딩 추가",
      "add-group": "회사 추가",
      "edit-group": "회사 정보 수정",
      "delete-group": "회사 삭제",
      edit: "수정",
      delete: "삭제",
      close: "닫기",
      "group-delete-title": "회사 정보 삭제",
      "group-delete-content":
        "선택하신 회사를 삭제하게 되면 회사에<br/>포함된 모든 회의실정보가 삭제됩니다.<br/>삭제 하시겠습니까?",
      "building-delete-title": "빌딩 삭제",
      "building-delete-content": "선택하신 빌딩을 삭제하시겠습니까?",
      "building-delete-complete": "빌딩이 삭제 되었습니다.",
      "no-import-room-data":
        "Import 할 회의실 데이터가 없습니다. Excel File 을 확인하세요.",
      group: {
        "group-add": "회사추가",
        "group-edit": "회사수정",
        name: "*회사이름",
        "add-complete": "회사가 추가 되었습니다.",
        "edit-complete": "회사가 수정 되었습니다.",
      },
      building: {
        "building-add": "빌딩추가: {groupName}",
        "building-edit": "빌딩수정",
        name: "*건물이름",
        "bottom-floor": "*저층",
        "top-floor": "*고층",
        country: "*국가명",
        state: "*지역(도시)",
        "floor-invaild": "고층의 값이 저층보다 작습니다.",
        "add-complete": "빌딩이 추가 되었습니다.",
        "edit-complete": "빌딩이 수정 되었습니다.",
      },
      "meeting-room": {
        "building-select": "건물을 선택하세요.",
        "room-select": "회의실 선택",
        add: "회의실 추가",
        floor: "회의실 위치",
        name: "회의실 이름",
        type: "회의실 타입",
        "type-room": "일반",
        "type-video": "화상",
        status: "회의실 상태",
        "status-waiting": "대기중",
        "status-in-meeting": "사용중",
        capacity: "수용인원",
        modify: "수정",
        "edit-delete": "삭제",
        "delete-title": "회의실 삭제",
        "delete-content": "선택하신 회의실을 삭제하시겠습니까?",
        "delete-complete": "회의실이 삭제 되었습니다.",
      },
      "add-edit-room": {
        add: "회의실 추가",
        edit: "회의실 수정",
        name: "*회의실 이름",
        type: "*회의실 타입",
        floor: "*위치",
        capacity: "*수용인원",
        manager: "*담당자",
        "sub-manager": "부담당자",
        "reserve-department": "회의실 사용 권한 부여",
        "reserve-manager": "예약 관리자",
        "room-manager": "회의실 관리자",
        "room-name": "회의실 명",
        "manager-name": "*관리자 이름",
        "manager-phone": "*연락처",
        "room-email": "회의실 Email",
        items: "공지사항",
        "add-complete": "회의실이 추가 되었습니다.",
        "edit-complete": "회의실이 수정 되었습니다.",
        "is-approve": "승인 사용 여부",
      },
      "export-column": {
        company: "Company",
        companyEng: "CompanyEng",
        building: "Building",
        "building-country": "Building Country",
        "building-city": "Building City",
        "room-name": "Room Name",
        "room-type": "Room Type",
        floor: "Location",
        capacity: "Capacity",
        "manager-email": "Manager Email",
        "reserv-department": "Grant meeting room permissions.",
        "reserv-email": "Reservation Manager Email",
        roomEmail: `room's Email`,
        items: "Items",
        manufacturer: "Device Manufacturer",
        ip: "Device IP",
        model: "Device Model",
        "sw-version": "Device SW Version",
        "device-manager-email": "Device Manager Email",
        "display-name": "Device Display Name",
        "device-id": "Device ID",
        "device-pw": "Device PW",
      },
      "field-missing": "* 필드 값을 입력해 주세요.",
      "people-unit": "명",
      "floor-unit": "층",
    },
    "device-mgr": {
      "device-list": "화상장비 리스트",
      "company-group": "회사",
      building: "건물",
      location: "본부",
      type: "타입",
      room: "회의실",
      "personal-device": "개인단말",
      "room-name": "회의실 이름",
      "device-url": "단말 DN",
      "device-ip": "단말 IP",
      "device-id": "단말 ID",
      "device-model": "단말 모델",
      "device-link": "단말 링크",
      contacts: "주소록",
      "device-status": "단말 상태",
      modify: "수정",
      "edit-delete": "삭제",
      import: "Import",
      export: "Export",
      favorites: "즐겨찾기",
      live: "활성화",
      down: "비활성화",
      ping: "확인중",
      favorite: {
        registor: "등록",
        add: "추가",
        apply: "적용",
        edit: "수정",
        delete: "삭제",
        "favorite-name": "즐겨찾기 명",
        number: "Number",
        name: "이름",
        folder: "위치",
        "add-complete": "즐겨찾기가 등록되었습니다.",
        "edit-complete": "즐겨찾기가 수정되었습니다.",
        "delete-complete": "즐겨찾기가 삭제되었습니다.",
        "apply-title": "{favoriteName} - 적용 장비 선택",
        "folder-add": "폴더 추가",
        "contact-add": "연락처 추가",
        "favorite-name-missing": "즐겨찾기 이름을 채워주세요.",
        "favorite-info-missing": "즐겨찾기 데이터를 채워주세요.",
      },
      "digital-signage": "디지털 사이니지",
      branding: "브랜딩",
      "add-edit-device": {
        "add-device": "화상장비 추가",
        "edit-device": "화상장비 수정",
        building: "건물",
        type: "타입",
        room: "회의실",
        "device-name": "단말 이름",
        user: "사용자",
        manufacturer: "제조사",
        "join-type": "회의 참여 방법",
        "device-ip": "단말 IP",
        "device-url": "단말 DN",
        "display-name": "단말 DN",
        version: "SW 버전",
        "device-model": "단말 모델",
        manager: "관리자",
        "reserve-manager": "예약 관리자",
        "manager-name": "관리자 이름",
        "manager-phone": "관리자 연락처",
        "device-id": "단말 ID",
        "device-pw": "단말 Password",
        save: "저장",
        cancel: "취소",
        "edit-comp-msg": "화상장비가 수정 되었습니다.",
        "add-comp-msg": "화상장비가 등록 되었습니다.",
      },
      "delete-device-title": "화상장비 삭제",
      "delete-device-content": "선택하신 화상장비를 삭제하시겠습니까?",
      "delete-device-complete": "화상장비가 삭제 되었습니다.",
      "field-missing": "필수 항목을 입력 하세요.",
    },
    "device-list": {
      "device-list": "화상장비 정보",
      "search-filter": "검색 조건",
      building: "건물",
      type: "타입",
      room: "회의실",
      "personal-device": "개인단말",
      "room-name": "회의실 이름",
      "device-url": "단말 DN",
      "device-ip": "단말 IP",
      "device-id": "단말 ID",
      "device-link": "단말 링크",
      contacts: "주소록",
      "device-status": "단말 상태",
      company: "회사",
    },
    "layout-mgr": {
      "layout-reg": "레이아웃 추가",
      name: "레이아웃 이름",
      "layout-template-id": "레이아웃 템플릿 ID",
      "callleg-profile-id": "콜레그 프로파일 ID",
      "max-important": "최대 지정 사용자 수",
      "max-fixable-num": "고정 가능 사용자 수",
      "avail-auto-switch": "사용자 자동 전환 설정",
      image: "이미지",
      info: "정보",
      edit: "수정",
      "layout-edit": "레이아웃 수정",
      delete: "삭제",
      "delete-layout-title": "레이아웃 삭제",
      "delete-layout-content": "선택하신 레이아웃을 삭제하시겠습니까?",
      "delete-layout-complete": "레이아웃이 삭제 되었습니다.",
      "add-comp-msg": "레이아웃이 추가되었습니다.",
      "edit-comp-msg": "레이아웃이 수정되었습니다.",
    },
    "help-desk": {
      "help-desk": "Help Desk",
      "system-admin": "시스템 관리자",
      "site-representative": "본부 담당자",
      company: "회사",
      position: "직급",
      mobile: "연락처",
      name: "이름",
      "emp-num": "사번",
      email: "이메일",
      location: "본부",
    },
    "user-mgr": {
      "role-mgr": {
        "manager-list": "관리자 리스트",
        "role-management": "권한 관리",
        "manager-registration": "관리자 추가 등록",
        "delete-users": "계정 삭제",
        role: "역할",
        company: "회사 명",
        name: "성명",
        department: "부서",
        info: "정보",
        "start-date": "시작 날짜",
        "end-date": "종료 날짜",
        "is-use": "사용 여부",
        modify: "수정",
        "edit-delete": "삭제",
        delete: "삭제",
        "search-manager": "사용자 조회",
        search: "검색",
        use: "사용",
        "un-use": "미사용",
        add: "추가",
        edit: "수정",
        close: "닫기",
        "field-missing": "필수 항목을 입력 하세요.",
        save: "저장",
        "role-page": "페이지 권한",
        "company-site-selection": "회사 및 사이트 선택",
      },
      local: {
        "user-list": "사용자 리스트",
        "local-db-user-msg": "로컬 DB에 등록된 사용자입니다.",
        "email-name-search": "사번 / 이름 찾기",
        email: "이메일",
        name: "이름",
        "create-time": "등록일",
        role: "권한",
        status: "상태",
        delete: "삭제",
        "delete-user-title": "사용자 삭제",
        "delete-user-content": "선택하신 사용자를 삭제하시겠습니까?",
        cancel: "취소",
        "role-admin": "관리자",
        "role-user": "사용자",
        "role-change-msg": " 님의 권한이 변경되었습니다.",
        "user-active-msg": " 님의 상태가 Active 되었습니다.",
        "delete-user-msg": "사용자가 삭제 되었습니다.",
        "cannot-delete-myself": "자신의 계정은 삭제 할 수 없습니다.",
        "license-manage": "라이선스 관리",
        "user-search": "사용자 검색",
        "assign-usr-list": "라이선스 할당 사용자",
        "license-assign-complete": "라이선스 할당이 완료 되었습니다.",
        "license-assign-fail": "라이선스 할당이 실패 하였습니다.",
        "sso-login-msg":
          "라이센스 할당 및 삭제는 관리자 계정의 Teams ID 로그인이 필요합니다.",
        "license-sso-login-admin-msg":
          "관리자 계정만 라이센스 등록이 가능합니다. Webex Teams Login 및 계정 권한을 확인하세요.",
      },
    },
    "webex-license": {
      "user-list": "웹엑스 사용자 리스트",
      "email-name-search": "이메일 / 이름 찾기",
      email: "이메일",
      name: "이름",
      "create-time": "등록일",
      role: "권한",
      status: "상태",
      delete: "삭제",
      "delete-user-title": "사용자 삭제",
      "delete-user-content": "선택하신 사용자를 삭제하시겠습니까?",
      cancel: "취소",
      "role-admin": "관리자",
      "role-user": "사용자",
      "role-change-msg": " 님의 권한이 변경되었습니다.",
      "user-active-msg": " 님의 상태가 Active 되었습니다.",
      "delete-user-msg": "사용자가 삭제 되었습니다.",
    },
    "system-mgr": {
      "organization-composition": {
        "organization-composition": "조직도 구성",
        "organization-info-sync": "조직 정보 동기화",
        "sync-time-setting": "동기화 시간 설정",
        "immediately-sync-comp-msg": "동기화가 완료 되었습니다.",
        "immediately-sync-fail-msg": "동기화가 실패 하였습니다.",
        "auto-sync": "자동 동기화",
        "immediately-sync": "지금 동기화",
        "local-db": "로컬DB",
        ldap: "LDAP",
        "personnel-db": "인사DB연동",
        "local-db-desc": "로컬 DB는 추가적인 설정이 필요 없습니다.",
        "setting-changed-msg": "조직도 세팅이 변경되었습니다.",
        "add-ldap": "LDAP 추가",
        "edit-ldap": "LDAP 수정",
        title: "이름",
        comment: "설명",
        ip: "IP 주소",
        port: "Port",
        "user-name": "Username",
        pw: "Password",
        "base-node": "Base Node",
        filter: "Filter",
        status: "상태",
        "last-sync-time": "마지막 동기화 시간",
        add: "추가",
        sync: "동기화",
        modify: "수정",
        "edit-delete": "삭제",
        save: "저장",
        cancel: "취소",
        "delete-ldap-title": "Ldap 삭제",
        "delete-ldap-content": "선택하신 Ldap 정보를 삭제하시겠습니까?",
        "delete-ldap-complete": "Ldap이 삭제 되었습니다.",
        "edit-comp-msg": "Ldap이 수정 되었습니다.",
        "add-comp-msg": "Ldap이 등록 되었습니다.",
        "ldap-sync-comp-msg": "Ldap 동기화가 완료되었습니다.",
        "change-site-setting": "시스템 설정 변경",
        "change-site-setting-info":
          "시스템 설정 변경은 페이지가 새로고침 됩니다.",
        "invaild-db-info-value": "입력값이 올바르지 않습니다.",
        "notice-alert": "공지사항 변경",
        "notice-alert-max-130": "공지사항은 130자 까지만 가능합니다.",
        "notice-alert-two-line": "공지사항은 2줄까지만 표시됩니다.",
      },
      "meeting-composition": {
        "system-config": "시스템 관리",
        "meeting-composition": "회의 구성",
        "meeting-record-init": "예약시 녹화 기본값",
        "lecture-mute-init": "강의시 음소거 기본값",
        "meeting-join-before-time": "회의 시작 전 참가 가능 시간(분)",
        "meeting-reserve-interval": "캘린더 시간 간격(분)/ 슬롯",
        "work-hours": "일과 시간",
        "setting-changed-msg": "회의 구성이 변경되었습니다.",
        "cost-saving-unit": "원",
        "cost-saving-per-hour": "회의 시간당 절감 비용",
        "use-room-meeting": "일반회의 사용",
        "room-device-import": "회의실, 화상장비 Import",
      },
      "webex-composition": {
        "webex-composition": "웹엑스 구성",
        "chat-bot-use": "Webex Chat Bot 사용",
        "setting-changed-msg": "웹엑스 세팅이 변경되었습니다.",
      },
      "smtp-setting": {
        "smtp-setting": "SMTP 구성",
        "from-email": "From Email",
        host: "Host",
        port: "Port",
        "user-name": "User Name",
        password: "Password",
        "password-confirm": "Confirm Password",
        "setting-changed-msg": "SMTP 설정이 변경되었습니다.",
        "invaild-value": "입력값이 올바르지 않습니다.",
      },
      "manager-setting": {
        "manager-setting": "사이트 설정",
        "main-page": "메인화면 선택하기",
        "dashboard-detail": "대시보드 상세보기",
        "user-view-record-page": "사용자 녹화파일 보기",
        "notice-msg": "공지사항 메시지(최대 2줄, 130자)",
        "popup-notice-msg": "메인 팝업 공지사항 메시지",
        "help-desk-number": "Help Desk",
        "system-manager": "시스템 관리자",
        "site-representative": "본부 담당자",
        "search-help-desk": "예약자",
        "cisco-webex-hub": "Cisco Webex Hub Address",
        "notice-duration": "공지사항 알림 시간",
        "setting-changed-msg": "사이트 설정이 변경되었습니다.",
      },
      "reduce-cost": {
        title: "절감금액",
        inside: "관내지역",
        outside: "관외지역",
        oversea: "해외지역",
        won: "원",
      },
      save: "저장하기",
      revert: "되돌리기",
    },
    "manual-download": {
      msg: {
        "upload-complete": "매뉴얼이 업로드 되었습니다.",
        "delete-complete": "매뉴얼이 삭제 되었습니다.",
      },
      confirm: "확인",
      "file-upload": "파일 업로드",
      "manual-downlaod": "매뉴얼 다운로드",
    },
    "meeting-control": {
      "lms-meeting-name": "과정명",
      "lms-meeting-time": "교육 시간",
      "lms-control": "제어",
      "lms-locked-call": "교육방 잠금",
      "lms-open-call": "교육방 잠금해제",
      host: "주관자",
      "open-call": "회의방 잠금해제",
      "locked-call": "회의방 잠금",
      "fixed-layout": "중요 레이아웃(4가지)",
      "fixed-layout-pop-title": "중요 레이아웃",
      "all-connection": "전체 연결",
      "meeting-control": "회의 제어",
      "not-select": "선택하지 않음",
      invitation: "추가 초대",
      "invitation-fail-msg": "추가초대를 실패 하였습니다.",
      "mute-success-msg": "음소거 설정을 완료 하였습니다.",
      "mute-fail-msg": "음소거 설정을 실패 하였습니다.",
      "all-mute": "전체 음소거",
      "all-un-mute": "전체 음소거 해제",
      "already-invited-people":
        "{peopleList} 는/은 이미 회의에 초대된 사용자 입니다.",
      refresh: "새로고침",
      close: "닫기",
      "meeting-end": "회의종료",
      "record-start": "녹화시작",
      detail: {
        detail: "참여자 상세정보",
        name: "참여자 이름",
        id: "참여자 ID",
        type: "Type",
        "type-subtype": "Type / SubType",
        "sub-type": "SubType",
        direction: "Direction",
        "duration-seconds": "참여 시간(초)",
        layout: "Layout",
        "rx-audio": {
          "rx-audio": "RX Audio",
          "packet-loss-per": "Packet Loss Percentage",
          jitter: "Jitter",
          "bit-rate": "BitRate",
        },
        "tx-audio": {
          "tx-audio": "TX Audio",
          "packet-loss-per": "Packet Loss Percentage",
          jitter: "Jitter",
          "bit-rate": "BitRate",
          "round-trip-time": "Round Trip Time",
        },
        "rx-video": {
          "rx-video": "RX Video",
          "packet-loss-per": "Packet Loss Percentage",
          jitter: "Jitter",
          "bit-rate": "BitRate",
        },
        "tx-video": {
          "tx-video": "TX Video",
          "packet-loss-per": "Packet Loss Percentage",
          jitter: "Jitter",
          "bit-rate": "BitRate",
          "round-trip-time": "Round Trip Time",
          width: "Width",
          height: "Height",
          "frame-rate": "Frame Rate",
        },
      },
      "attendee-list": {
        type: "참여유형",
        "participant-type": "타입",
        person: "사용자",
        device: "화상장비",
        invited: "초대여부",
        inviter: "초대자",
        "non-inviter": "비 초대자",
        "attendee-name": "참여자 이름",
        status: "상태",
        "on-line": "참여",
        "off-line": "미참여",
        mic: "마이크",
        camera: "카메라",
        connection: "연결",
        "hang-up": "끊기",
        layout: "레이아웃",
        detail: "연결정보",
      },
      "device-list": {
        name: "회의실(코덱) 명",
        model: "장비 모델",
        "webex-conn-status": "Webex 접속 상태",
        status: "단말 상태",
        ip: "단말 IP",
        link: "단말 Link",
        connection: "연결",
        "hang-up": "끊기",
      },
      "refresh-all": "전체 새로고침",
      "refresh-all-content":
        "장비가 많으면 시간이 오래 걸릴 수 있습니다.\n전체 새로고침을 하시겠습니까?",
      confirm: "확인",
      "dial-err-msg": "화상 장비의 회의 연결을 실패 하였습니다.",
      "disconnect-err-msg": "화상 장비의 연결 끊기를 실패 하였습니다.",
      "invite-select": "추가 초대",
      "room-invite": "회의실 초대",
      "personal-device-invite": "개인 단말 초대",
      "no-dial-list-msg":
        "더이상 연결 할 회의실(코덱)가 없습니다. 새로고침 후 상태를 확인 하세요.",
    },
    log: {
      "date-filter-invaild-msg": "{durationDay}일 까지만 검색 가능 합니다.",
    },
    "cospace-management": {
      "add-edit-cospaces": {
        add: "Cosapce 추가",
        edit: "Cosapce 수정",
        close: "닫기",
        name: "Cospace 이름",
        uri: "URI",
        layout: "레이아웃",
        "add-complete": "Cospace가 생성되었습니다.",
        "edit-complete": "Cospace가 생성되었습니다.",
      },
    },
    "init-info": {
      "first-line": "반갑습니다. 처음 접속하셨네요.",
      "second-line": "회사와 위치 정보를 입력해주세요.",
      "third-line": "추후 사용자 프로필에서 변경이 가능합니다.",
    },
    "external-users": {
      empnum: "ID",
      name: "이름",
      email: "이메일",
      department: "회사",
      title: "직급",
      password: "비밀번호",
      phone: "전화번호",
      "request-user": "등록자",
      created: "등록일",
      "approval-user": "승인자",
      status: "상태",
      "reset-pw": "비밀번호 초기화",
      reset: "초기화",
      approve: "승인",
      reject: "거절",
      cancel: "삭제",
      "req-cancel": "삭제",
      "all-status": "모든 상태",
      request: "승인 대기",
      search: "이름/이메일/ID",
      "reset-pw-user": "비밀번호 초기화",
      "reset-pw-user-content": '비밀번호를 "{password}"로 초기화 하시겠습니까?',
      "reset-pw-user-msg": "비밀번호가 초기화 되었습니다.",
      "approve-user": "사용자 승인",
      "approve-user-content": "선택하신 사용자를 승인하시겠습니까?",
      "approved-user": "사용자가 승인되었습니다.",
      "reject-user": "사용자 반려",
      "reject-user-content": "선택하신 사용자를 반려하시겠습니까?",
      "rejected-user": "사용자가 반려 되었습니다.",
      "cancel-user": "협력회사 사용자 삭제",
      "cancel-user-content": "선택하신 협력회사 사용자를 삭제하시겠습니까?",
      "cancel-user-msg": "협력회사 사용자가 삭제 되었습니다.",
      "add-user": "등록",
      add: "등록",
      edit: "수정",
      close: "닫기",
      "extertnal-user-add": "협력회사 사용자 등록",
      "extertnal-user-edit": "협력회사 사용자 수정",
      "field-missing": "필수 항목을 입력 하세요.",
      "field-kepco-email": "@kepco.co.kr 은 등록할 수 없습니다.",
      "invaild-email": "이메일 포맷을 확인하세요",
      "add-complete": "사용자가 등록 되었습니다.",
      "edit-complete": "사용자가 수정 되었습니다.",
    },
    "external-edu-users": {
      empnum: "ID",
      name: "이름",
      email: "이메일",
      department: "회사",
      title: "직급",
      password: "비밀번호",
      phone: "전화번호",
      "request-user": "등록자",
      created: "등록일",
      "approval-user": "승인자",
      status: "상태",
      "reset-pw": "비밀번호 초기화",
      reset: "초기화",
      approve: "승인",
      reject: "거절",
      cancel: "삭제",
      "req-cancel": "삭제",
      "all-status": "모든 상태",
      request: "승인 대기",
      search: "이름/이메일/ID",
      "reset-pw-user": "비밀번호 초기화",
      "reset-pw-user-content": '비밀번호를 "{password}"로 초기화 하시겠습니까?',
      "reset-pw-user-msg": "비밀번호가 초기화 되었습니다.",
      "approve-user": "강사 승인",
      "approve-user-content": "선택하신 강사를 승인하시겠습니까?",
      "approved-user": "강사가 승인되었습니다.",
      "reject-user": "강사 반려",
      "reject-user-content": "선택하신 강사를 반려하시겠습니까?",
      "rejected-user": "강사가 반려 되었습니다.",
      "cancel-user": "강사 삭제",
      "cancel-user-content": "선택하신 강사를 삭제하시겠습니까?",
      "cancel-user-msg": "강사가 삭제 되었습니다.",
      "add-user": "등록",
      add: "등록",
      edit: "수정",
      close: "닫기",
      "extertnal-user-add": "강사 등록",
      "extertnal-user-edit": "강사 수정",
      "field-missing": "필수 항목을 입력 하세요.",
      "field-kepco-email": "@kepco.co.kr 은 등록할 수 없습니다.",
      "invaild-email": "이메일 포맷을 확인하세요",
      "add-complete": "강사가 등록 되었습니다.",
      "edit-complete": "강사가 수정 되었습니다.",
    },
  },
};

export default message;



// WEBPACK FOOTER //
// ./src/i18n/kr.js